import { render } from "./UtilityHome.vue?vue&type=template&id=4b6b6980&scoped=true"
import script from "./UtilityHome.vue?vue&type=script&lang=js"
export * from "./UtilityHome.vue?vue&type=script&lang=js"

import "./UtilityHome.vue?vue&type=style&index=0&id=4b6b6980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6b6980"]])

export default __exports__